export default [{
  path: '/',
  component: resolve => require(['./index.vue'], resolve)
}, {
  path: '/calendar',
  component: resolve => require(['./modules/calendar.vue'], resolve)
},{
  name: 'selectCity',
  path: '/selectCity',
  component: resolve => require(['./modules/select-city.vue'], resolve)
}, {
  name: 'WeChatCustomerCervice',
  path: '/WeChatCustomerCervice',
  component: resolve => require(['./modules/WeChatCustomerCervice.vue'], resolve)
}]



// WEBPACK FOOTER //
// ./src/views/router.js